import Vue from "vue/dist/vue.esm";
// 出走用単独ページ用js
import autoDetailAthletes from './auto/detail_athletes';
import keirinDetailAthletes from './keirin/detail_athletes';

if (gameType == chari.const.GAME_TYPE.autorace) {
  var detailAthletesTable = {
    extends: autoDetailAthletes.detailAthletes,
    props: ['raceInfo']
  };
} else {
  var detailAthletesTable = {
    extends: keirinDetailAthletes.detailAthletes,
    props: ['raceInfo']
  };
}

const vm = new Vue({
  el: '#app-athletes',
  data: {
    gameType: gameType,
    open_day: open_day,
    vel_code: vel_code,
    race_num: race_num,
    end_of_sale_question: true,
    raceInfo: {}
  },
  components: {
    'detailAthletesTable': detailAthletesTable
  },
  methods: {
    // 選手の情報なども含まれる
    fetchRaceInfo: function() {
      var params = {
        "open_day": this.open_day,
        "vel_code": this.vel_code,
        "race_num": this.race_num
      };

      if (this.gameType == chari.const.GAME_TYPE.keirin) {
        chari.api.getKeirinRaceInfo(params, (res) => {
          this.raceInfo = res;
          this.end_of_sale_question = this.raceInfo.box.end_of_sale_question;
        });
      } else {
        chari.api.getAutoRaceInfo(params, (res) => {
          this.raceInfo = res;
          this.end_of_sale_question = this.raceInfo.box.end_of_sale_question;
        });
      }
    },
    voteURL: function() {
      if (this.gameType == chari.const.GAME_TYPE.keirin) {
        return '/keirin/' + this.open_day + '/' + this.vel_code + '/?race_num=' + this.race_num;
      } else {
        return '/auto/' + this.open_day + '/' + this.vel_code + '/?race_num=' + this.race_num;
      }
    }
  },
  created: function() {
    this.fetchRaceInfo();
  }
});
